import { Navigate } from 'react-router-dom';
import { checkPermissions } from '../helpers/checkPermissionHelper';
import { RegionService } from '../services/regionService';
import { AppRoutes } from '../constants/appRoutes';

export const RoutePermission = ({ authKey, authMultiKeys = [], children }) => {
	const regionService = new RegionService();
	if (!checkPermissions(authKey, authMultiKeys)) {
		return (
			<Navigate
				to={`/${regionService.currentRegion()}/${
					AppRoutes.Unauthorized
				}`}></Navigate>
		);
	}

	return children;
};
